/* eslint-disable react/jsx-no-undef */
import { FormContainer, StyledUniversalForm } from './styled';
import Fields from './fields';

interface FormProps {
    id?: string,
    initialValues?: Record<string, unknown>,
    disabledFields?: string[],
    agentId: string;
    onSubmit?: (values: Record<string, unknown>) => void,
    [key: string]: unknown;
}

interface FormValues extends Record<string, unknown> {
    phoneNumber?: string;
    provider?: string;
    pipeline?: string;
    params: Record<string, string>;
}

const mapFormValues = async (currentValues: FormValues) => {
    const {
        phoneNumber,
        pipeline,
        params,
        ...rest
    } = currentValues;

    return {
        ...rest,
        sid: phoneNumber,
        voicePipelineServer: {
            id: pipeline,
            params,
        },
    };
};

const Form = ({
    id,
    initialValues,
    disabledFields = [],
    agentId,
    onSubmit,
    ...rest
}: FormProps) => {
    const onSubmitMiddleware = async (formValues: Record<string, unknown>) => {
        if (onSubmit) onSubmit(await mapFormValues(formValues as FormValues));
    };

    return (
        <FormContainer>
            <StyledUniversalForm
                id={id}
                onSubmit={onSubmitMiddleware}
                initialValues={initialValues}
            >
                <Fields disabledFields={disabledFields} agentId={agentId} {...rest} />
            </StyledUniversalForm>
        </FormContainer>
    );
};

export default Form;
